import PropTypes from 'prop-types'
import styled from 'styled-components'
import toUpper from 'lodash/toUpper'

import colors from 'components/utils/colors'

const StyledWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  padding-bottom: 8px;
`

const Item = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${props => props.noUpperStyle ? '198px' : '127px'};
  height:  ${props => props.noUpperStyle ? '48px' : '78px'};;
  cursor: pointer;
  color: #000;
  opacity: 0.5;
  background-color: #FFFFFF;
  border-bottom: 3px solid transparent;
  text-align: center;

  &:hover {
    opacity: 1;
    img {
      filter: grayscale(0%);
    }
  }

  &.active {
    border-bottom: 3px solid ${colors.primary35};
    opacity: 1;
    cursor: default;

    img {
      filter: grayscale(0%);
    }
  }
`

const StyledImage = styled.img`
  max-height: 60px;
  filter: grayscale(100%);
  object-fit: cover;

  &:hover {
    filter: grayscale(0%);
  }
`

const CardsList = ({ onSelect, cards, selectedCardId, noUpperStyle }) => {
  return (
    <StyledWrapper noUpperStyle={noUpperStyle} data-test='cards-list'>
      {cards.map(card => {
        const cardId = card.id
        const cardName = card.name
        const isSelected = selectedCardId === cardId

        return (
          <Item
            className={isSelected ? 'active' : ''}
            key={cardId}
            onClick={() => onSelect(card)}
            data-test={cardName}
            noUpperStyle={noUpperStyle}
          >
            {card.icon
              ? <StyledImage src={card.icon} />
              : <div>{noUpperStyle ? cardName : toUpper(card.ticketProviderProjectName || card.name)}</div>
            }
          </Item>
        )
      })}
    </StyledWrapper>
  )
}

CardsList.propTypes = {
  onSelect: PropTypes.func.isRequired,
  cards: PropTypes.array.isRequired,
  noUpperStyle: PropTypes.bool,
  selectedCardId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
}

export default CardsList
